import React from "react";
import { Row, Col, Input, Button } from "reactstrap";
import { SALES_STAGES, LEAD_TEMPERATURES, LEAD_SOURCES } from "../../constants";

const PlatformCrmFilterBar = ({ filters, consultants = [], onChange }) => {
    const handleInputChange = (field, value) => {
        onChange({ [field]: value });
    };

    const handleClear = () => {
        onChange({
            consultantId: "",
            stage: "",
            temperature: "",
            source: "",
            search: ""
        });
    };

    const hasFiltersActive = Object.values(filters).some(val => val !== "");

    return (
        <div className="card p-3 mb-4 shadow-sm rounded border-0 crm-filters-card">
            <Row className="gy-2 align-items-center">
                <Col lg={3} md={4} sm={12}>
                    <div className="search-box position-relative">
                        <Input
                            type="text"
                            placeholder="Buscar academia, dono ou e-mail..."
                            value={filters.search}
                            onChange={(e) => handleInputChange("search", e.target.value)}
                            className="form-control"
                        />
                    </div>
                </Col>
                
                <Col lg={2} md={4} sm={6}>
                    <Input
                        type="select"
                        value={filters.consultantId}
                        onChange={(e) => handleInputChange("consultantId", e.target.value)}
                        className="form-select"
                    >
                        <option value="">Todos os Consultores</option>
                        {consultants.map(c => (
                            <option key={c.id} value={c.id}>{c.fullName}</option>
                        ))}
                    </Input>
                </Col>

                <Col lg={2} md={4} sm={6}>
                    <Input
                        type="select"
                        value={filters.temperature}
                        onChange={(e) => handleInputChange("temperature", e.target.value)}
                        className="form-select"
                    >
                        <option value="">Todas as Temperaturas</option>
                        {Object.entries(LEAD_TEMPERATURES).map(([key, config]) => (
                            <option key={key} value={key}>{config.label}</option>
                        ))}
                    </Input>
                </Col>

                <Col lg={2} md={4} sm={6}>
                    <Input
                        type="select"
                        value={filters.source}
                        onChange={(e) => handleInputChange("source", e.target.value)}
                        className="form-select"
                    >
                        <option value="">Todas as Origens</option>
                        {LEAD_SOURCES.map(s => (
                            <option key={s.key} value={s.key}>{s.label}</option>
                        ))}
                    </Input>
                </Col>

                <Col lg={2} md={4} sm={6}>
                    <Input
                        type="select"
                        value={filters.stage}
                        onChange={(e) => handleInputChange("stage", e.target.value)}
                        className="form-select"
                    >
                        <option value="">Todos os Estágios</option>
                        {SALES_STAGES.map(s => (
                            <option key={s.key} value={s.key}>{s.label}</option>
                        ))}
                    </Input>
                </Col>

                {hasFiltersActive && (
                    <Col lg={1} md={12} sm={12} className="text-end">
                        <Button 
                            color="link" 
                            onClick={handleClear} 
                            className="p-0 text-decoration-none text-muted fw-semibold font-size-13 w-100"
                        >
                            Limpar
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default PlatformCrmFilterBar;
